import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  MARK_BOLD,
  MARK_ITALIC,
  MARK_STRIKETHROUGH,
  MARK_UNDERLINE,
  ToolbarMark,
} from '@udecode/slate-plugins';

import { StyledButton } from './styles';
import { Sizes as ButtonSizes } from '../../Button/Button';
import { Bold as BoldIcon } from '@icons/editor';
import { Italic as ItalicIcon } from '@icons/editor';
import { Underline as UnderlineIcon } from '@icons/editor';
import { Strikethrough as StrikeThroughIcon } from '@icons/editor';

export const ITEMS = {
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  STRIKETHROUGH: 'strikethrough',
};

const TYPES = {
  [ITEMS.BOLD]: MARK_BOLD,
  [ITEMS.ITALIC]: MARK_ITALIC,
  [ITEMS.UNDERLINE]: MARK_UNDERLINE,
  [ITEMS.STRIKETHROUGH]: MARK_STRIKETHROUGH,
};

const ICONS = {
  [ITEMS.BOLD]: <BoldIcon height={10} />,
  [ITEMS.ITALIC]: <ItalicIcon height={10} />,
  [ITEMS.UNDERLINE]: <UnderlineIcon height={10} />,
  [ITEMS.STRIKETHROUGH]: <StrikeThroughIcon height={10} />,
};

const MarkButton = ({ name }) => (
  <StyledButton size={ButtonSizes.FLEX}>{ICONS[name]}</StyledButton>
);

const Toolbar = React.memo(({ marks, buttons }) => (
  <StyledToolBar>
    {marks.map(mark => (
      <ToolbarMark
        key={mark}
        type={TYPES[mark]}
        icon={<MarkButton name={mark} />}
      />
    ))}
    {buttons.map(button => button())}
  </StyledToolBar>
));

Toolbar.propTypes = {
  marks: PropTypes.arrayOf(PropTypes.string),
  buttons: PropTypes.arrayOf(PropTypes.element),
};

Toolbar.defaultProps = {
  marks: [ITEMS.BOLD, ITEMS.ITALIC, ITEMS.UNDERLINE, ITEMS.STRIKETHROUGH],
  buttons: [],
};

MarkButton.propTypes = {
  name: PropTypes.string.isRequired,
};

Toolbar.displayName = 'Toolbar';

const StyledToolBar = styled.div`
  display: flex;
  align-items: center;
  padding: 2px;
  background: #f5f3f2;
  border-radius: 20px;
  margin-bottom: 5px;

  .slate-ToolbarButton-active {
    button {
      background: #f3f2e8;
    }
  }
`;

Toolbar.ITEMS = ITEMS;

export default Toolbar;
